import { ColumnDef } from '@tanstack/react-table'
import { Checkbox } from '@/components/ui/checkbox'
import { RowComponent } from '@/lib/types/table.types'

export const checkboxColumn = <
  T extends Record<string, any>,
>(): ColumnDef<T>[] => [
  {
    accessorKey: 'select',
    maxSize: 72,
    enableResizing: false,
    enableColumnFilter: false,
    header: ({ table }) => (
      <Checkbox
        className='border-zinc-800'
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        aria-label='Select all rows'
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label='Select row'
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
]

export const actionColumn = <T extends Record<string, any>>(
  Component: RowComponent<T>,
  size: number = 200,
): ColumnDef<T>[] => [
  {
    accessorKey: 'actions',
    enableSorting: false,
    header: 'Actions',
    enableColumnFilter: false,
    enableResizing: false,
    minSize: size,
    size,
    cell: ({ row }) => <Component row={row} />,
  },
]
